import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { DirectMessagePreviewFileComponent } from 'src/app/ChildControls/direct-message-preview-file/direct-message-preview-file.component';
import { SurescriptsClinicalDirectMessageComponent } from 'src/app/ChildControls/surescripts-clinical-direct-message/surescripts-clinical-direct-message.component';
import { directDocAttachment, directmessageDTO } from 'src/app/models/IPharmacyDirectory';
import { PatientSearchComponent } from 'src/app/patient-search/patient-search.component';
import { ViewDocumentComponent } from 'src/app/PatientChart/Document/view-document/view-document.component';
import { PastNotesComponent } from 'src/app/PatientChart/past-notes/past-notes.component';
import { DocumentService } from 'src/app/Services/Documents/document.service';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { configuration } from 'src/environments/environment';
import suneditor from 'suneditor'
import plugins from 'suneditor/src/plugins'
import { DmProviderSearchComponent } from '../dm-provider-search/dm-provider-search.component';
import { saveAs } from 'file-saver';
import { decode } from 'base64-arraybuffer';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { GetCCDAMessageComponent } from 'src/app/CCDA/get-ccdamessage/get-ccdamessage.component';
import { AuditLog } from 'src/app/models/iauditlog.model';
import { Router } from '@angular/router';
import { ViewzipfilesComponent } from './viewzipfiles/viewzipfiles.component';
import { ThirdPartyDraggable } from '@fullcalendar/interaction';
import { ICptOrdersComponent } from 'src/app/models/ICptOrdersComponent';
import { CptordersService } from 'src/app/Services/NewVisitNote/cptorders.service';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-direct-messages',
  templateUrl: './direct-messages.component.html',
  styleUrls: ['./direct-messages.component.css']
})
export class DirectMessagesComponent implements OnInit {
  hidetab: boolean = false;
  composeProp: boolean = false;
  inboxProp: boolean = true;
  inboxViewMail: boolean = false;
  viewInbox: boolean = true;
  directmessageform: FormGroup;
  patId: number;
  firstname: string;
  lastname: string;
  patgender: string;
  patDOB: string;
  patZip: string;
  directMessagedetails: directmessageDTO;
  dmmsgTo: string;
  dmmsgCC: string;
  displayedColumns: string[] = ['sender', 'subject', 'datetime', 'Status', 'action'];
  senderFilter = new FormControl('');
  subjectFilter = new FormControl('');
  dateTimeFilter = new FormControl('');
  StatusFilter = new FormControl('');
  dmDataSource: any = new MatTableDataSource();
  filterValues = { sender: '', subject: '', datetime: '', Status: '' };
  directaddress: string = '';
  isorder; orderid = 0; encounterid = null;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(public dialog: MatDialog, private formBuilder: FormBuilder, public rxService: RxService
    , private toastr: ToastrService, private docService: DocumentService
    , private sanitizer: DomSanitizer
    , private spinner: NgxSpinnerService
    , private msgservice: MessagesService
    , private sharedService: SharedService
    , @Inject(MAT_DIALOG_DATA) public data: any
    , private router: Router, public cptservice: CptordersService) {
    if (sessionStorage.getItem("directaddress"))
      this.directaddress = sessionStorage.getItem("directaddress").toString();
    if (data) {
      this.patId = data.patientid
      this.isorder = data.isorder;
      this.orderid = data.orderid;
      this.encounterid = data.encounterid;
    }
  }

  ngOnInit() {
    $('.boxback').removeClass('boxback');
    // setTimeout(() => {
    //   this.editorinit();
    // }, 500);
    this.Activeclass = "I";
    this.dmDataSource.paginator = this.paginator;
    this.inboxProp = true;
    this.directmessageform = this.formBuilder.group({
      msgTo: ['',],
      msgCc: ['',],
      msgSubject: ['',],
      msgPatientname: ['',],
      msgPlainText: ['',],
      attachmentss: []
    });
    this.directMessagedetails = {
      patId: '',
      encounterId: null,
      firstName: '',
      lastName: '',
      dob: '',
      gender: '',
      zip: '',
      messageId: '',
      messageTo: '',
      messageCc: '',
      messageFrom: '',
      subject: '',
      bodyText: '',
      attachment: [],
      CreatedBy: '',
      dateTime: '',
      mId: null,
      TransformedXML: null,
      DMRId: null,
      isReceived: null,
      Statustext: '',
      htmlText: '',
      Status: '',
      containsAttachments: false,
      CDAXML: null,
      Type: null
    }
    this.attachmentss = {
      documentName: '',
      documenttype: '',
      documentVersion: '',
      documentdata: null,
      documentPath: null
    }
    this.GetDirectMessagesDetails('I')
    // Table column filters
    this.senderFilter.valueChanges
      .subscribe(
        messageFrom => {
          this.filterValues.sender = messageFrom;
          this.dmDataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.subjectFilter.valueChanges
      .subscribe(
        subject => {
          this.filterValues.subject = subject;
          this.dmDataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.dateTimeFilter.valueChanges
      .subscribe(
        dateTime => {
          this.filterValues.datetime = dateTime;
          this.dmDataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.StatusFilter.valueChanges
      .subscribe(
        Status => {
          this.filterValues.Status = Status;
          this.dmDataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.AuditLogs("USP_EMR_GET_DIRECTMESSAGE", 'I');
  }
  public _auditLog: AuditLog;
  AuditLogs(sp: any, input: any) {
    this._auditLog = new AuditLog();
    this._auditLog.InputParameters = input;
    this._auditLog.SPName = sp;
    this.sharedService.selectCopyPrintAuditLog(this._auditLog).subscribe(async result => {
      await result;
    });
  }
  funCompose() {
    this.directaddress = sessionStorage.getItem('directaddress').toString();
    if (this.directaddress == '' || this.directaddress == undefined || this.directaddress == 'undefined'
      || this.directaddress == "null"
    ) {
      this.toastr.error("No direct address for this provider;")
      return;
    }
    this.clearvalues();
    this.composeProp = true;
    this.inboxProp = false;
    if (this.initEditor)
      this.initEditor.destroy();
    $('.sun-editor .se-wrapper .se-wrapper-wysiwyg').css({ 'background-color': '#fff;', 'opacity': '1;' });
    // if(!this.initEditor)
    this.editorinit();
  }

  funViewMail() {
    this.composeProp = false;
    this.inboxProp = false;
    this.inboxViewMail = true;
  }
  attachmentname = "";
  initEditor: any;
  editorinit() {
    this.initEditor = suneditor.create((document.getElementById('DMeditor') || 'DMeditor'), {
      plugins: plugins,
      height: '400',
      width: '100%',
      fontSize: [8, 9, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48],
      /*buttonList: [
    ['undo', 'redo',
      'font', 'fontSize', 'formatBlock',
      'paragraphStyle',
      'bold', 'underline', 'italic',
      'fontColor', 'hiliteColor',
      'removeFormat',
      'outdent', 'indent',
      'horizontalRule', 'list', 'lineHeight',
      'align',
  'table', *  'align', 'strike', 'textStyle', 'subscript', 'superscript','blockquote','link', 'image', 'video', 'audio',  'math', */ // You must add the 'katex' library at options to use the 'math' plugin.
      /** 'imageGallery',  // You must add the "imageGalleryUrl".
      'fullScreen', 'showBlocks', 'codeView',
      'preview', 'print', 'save', 'template'
    ]
  ]*/
      buttonList: [
        ['undo', 'redo', 'font', 'fontSize', 'bold', 'underline', 'italic',
          'removeFormat', 'list', 'outdent', 'indent', 'align',
        ]
      ]
    });

    this.initEditor.toolbar.hide()
  }

  onProvidersearchClick(toorCC) {
    const dialogRef2 = this.dialog.open(DmProviderSearchComponent, {
      width: '1900px',
      height: '520px'
    });
    // ;
    dialogRef2.afterClosed().subscribe(result => {
      // this.pharmacyID=result.ncpdpId;
      var providerName = result.LastName == "" ? (result.DirectAddress) : (result.LastName + ', ' + result.FirstName + '(' + result.DirectAddress + ')');
      if (toorCC == "To") {
        this.directmessageform.patchValue({
          msgTo: (this.directmessageform.controls.msgTo.value == "" ? providerName
            : (this.directmessageform.controls.msgTo.value + ';' + providerName))
        })
      }
      else {
        this.directmessageform.patchValue({
          msgCc: (this.directmessageform.controls.msgCc.value == "" ? providerName
            : (this.directmessageform.controls.msgCc.value + ';' + providerName))
        })
      }
    });
  }

  openPatSearchWindow(): void {
    sessionStorage.setItem("ispatSerachPopup", "True");
    const dialogRef = this.dialog.open(PatientSearchComponent, {
      width: '1180px',
      maxWidth:'auto',
       height: 'auto',
      data: { action: true }
    }

    );

    dialogRef.afterClosed().subscribe(result => {

      if (result != undefined && result != '') {
        this.directmessageform.patchValue({
          msgPatientname: result.name,
        });
        this.patId = result.patientId;
        this.firstname = result.firstName;
        this.lastname = result.lastName;
        this.patDOB = result.dob;
        this.patgender = result.gender;
        if (result.postalCode)
          this.patZip = result.postalCode.replace('-', '');
        sessionStorage.setItem('patientId', this.patId.toString())
      }

    });

  }

  mapValuestoObject() {
    this.directMessagedetails.patId = String(this.patId);
    this.directMessagedetails.firstName = this.firstname;
    this.directMessagedetails.lastName = this.lastname;
    this.directMessagedetails.dob = this.patDOB;
    this.directMessagedetails.gender = this.patgender;
    this.directMessagedetails.zip = this.patZip;
    this.directMessagedetails.messageTo = this.directmessageform.controls.msgTo.value;
    this.directMessagedetails.messageCc = this.directmessageform.controls.msgCc.value;
    this.directMessagedetails.subject = this.directmessageform.controls.msgSubject.value;
    // this.directMessagedetails.bodyText = this.directmessageform.controls.msgPlainText.value;
    this.directMessagedetails.bodyText = this.initEditor.getText();
    this.directMessagedetails.htmlText = this.initEditor.getContents();
    this.directMessagedetails.messageFrom = sessionStorage.getItem('directaddress').toString(); //this.directaddress;// "senapati.m@VigiBossMD4Front.direct-ci-cert.com";
    this.directMessagedetails.CreatedBy = sessionStorage.getItem('userId').toString();
    this.directMessagedetails.attachment = [];
    this.directMessagedetails.attachment = this.lstattachments;
    // this.directMessagedetails.attachment.push(this.attachmentss);
    this.directMessagedetails.encounterId = this.encounterid;

  }

  onsendmessage() {
    this.mapValuestoObject();
    if (this.directMessagedetails.messageTo == '') {
      this.toastr.warning("Enter address to whom message is to be sent.");
      return;
    }
    if (this.directMessagedetails.subject == '') {
      this.toastr.warning("Enter subject of the message.");
      return;
    }
    if (this.directMessagedetails.attachment != null && this.directMessagedetails.attachment.length > 0) {
      let _size = 0;
      (this.directMessagedetails.attachment).forEach(element => {
        if (element.documentdata)
          _size += element.documentdata.length;
      });
      if (_size > 20971520) {
        this.toastr.error("Cannot upload more than 20MB");
        return;
      }
    }
    this.rxService.sendDirectmessagetoProvider(this.directMessagedetails).subscribe(result => {

      let msgid = result.split('##').length > 1 ? result.split('##')[1] : null;
      let res = result.split('##').length > 1 ? result.split('##')[0] : result;
      this.toastr.success(res);
      // alert(msgid);
      // this.clearvalues();
      // this.inboxProp = true;
      // this.composeProp = false;
      // this.inboxViewMail = false;
      if (this.isorder) {
        this.dialog.closeAll();
        let orderStatusObj = new ICptOrdersComponent();
        orderStatusObj.orderStatus = "Open";
        // orderStatusObj.routeStatus = "Print";
        orderStatusObj.printStatus = false;
        orderStatusObj.faxStatus = false;
        orderStatusObj.cptOrderId = this.orderid;
        orderStatusObj.encounterId = this.encounterid;
        orderStatusObj.categoryName = 'Specialist Referrals';
        orderStatusObj.DMId = msgid;
        this.cptservice.updateOrderTrackerStatus(orderStatusObj).subscribe(
          results => {
          });
        this.clearvalues();
        this.inboxProp = true;
        this.composeProp = false;
        this.inboxViewMail = false;
      }
      else {
        this.clearvalues();
        this.inboxProp = true;
        this.composeProp = false;
        this.inboxViewMail = false;
      }
    })
  }
  attachmentss: directDocAttachment;
  lstattachments: directDocAttachment[] = [];
  UploadDoc(event, type: string) {
    this.attachmentss = {
      documentName: '',
      documenttype: '',
      documentVersion: '',
      documentdata: null,
      documentPath: null
    }
    const file = (event.target as HTMLInputElement).files[0];
    const allowedMimeTypes = ["application/pdf", "application/rtf", "application/txt", "text/plain", "application/msword", "text/rtf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/html"];
    if (file && allowedMimeTypes.includes(file.type)) {
      const reader = new FileReader();
      this.attachmentss.documentName = file.name;
      this.attachmentss.documenttype = file.type;
      reader.onload = () => {
        // this.imageData = reader.result as string;       
        this.attachmentss.documentdata = (reader.result as string).split(',')[1];
        this.lstattachments.push(this.attachmentss);
        this.mapValuestoObject();
        //event.target.value = null;
      };
      reader.readAsDataURL(file);
    }

  }

  clearvalues() {
    this.directMessagedetails = {
      patId: '',
      encounterId: null,
      firstName: '',
      lastName: '',
      dob: '',
      gender: '',
      zip: '',
      messageId: '',
      messageTo: '',
      messageCc: '',
      messageFrom: '',
      subject: '',
      bodyText: '',
      attachment: [],
      CreatedBy: '',
      dateTime: '',
      mId: null,
      TransformedXML: null,
      DMRId: null,
      isReceived: null,
      Statustext: '',
      htmlText: '',
      Status: '',
      containsAttachments: false,
      CDAXML: null,
      Type: null
    }
    this.directmessageform.patchValue({
      msgTo: '',
      msgCc: '',
      msgSubject: '',
      msgPatientname: '',
      msgPlainText: '',
    });
    this.directmessageform.value.msgPlainText = '';
    this.lstattachments = [];
  }

  openDocumentsWindow(): void {
    if (this.patId > 0) {
      sessionStorage.setItem("hideDocumentsHeader", "true");
      const dialogRef = this.dialog.open(ViewDocumentComponent, {
        width: 'auto',
        height: 'auto',
        data: { isImport: false }
      }

      );

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined && result != '') {
          this.attachmentss = {
            documentName: '',
            documenttype: '',
            documentVersion: '',
            documentdata: null,
            documentPath: null
          }
          this.attachmentss.documentName = result.documentName;
          // this.attachmentss.documentName = encodeURIComponent(result.documentName);
          this.attachmentss.documenttype = "pdf";// result.extension;
          this.attachmentss.documentPath = result.Docpath; //+ '\\' + result.documentId;
          this.rxService.getDocumentData(this.attachmentss).subscribe(res => {
            this.attachmentss.documentdata = res;
            this.attachmentss.documenttype = "application/pdf";
            this.lstattachments.push(this.attachmentss);
            this.mapValuestoObject();
          });
          sessionStorage.removeItem("hideDocumentsHeader");
        }
        // if (result != undefined && result != '') {
        //   let ele = result.Docpath.split('\\');
        //   ele.shift()
        //   ele.push(result.documentId + "." + result.extension)
        //   const filepath0 = ele.join("/");
        //   const filePath1 = result.facilityId + "/" + result.patientId + "/" + result.docCategoryId + "/" + result.subCategoryId + "/" + result.documentId + "." + result.extension;
        //   const filePath2 = result.locationId + "/" + result.patientId + "/" + result.docCategoryId + "/" + result.subCategoryId + "/" + result.documentId + "." + result.extension;
        //   const urlArray: string[] = [];
        //   urlArray.push(filepath0);
        //   urlArray.push(filePath1);
        //   urlArray.push(filePath2);
        //   // this.isUrlFound(urlArray, element.documentName);
        //   this.docService.getValidFilePath(urlArray, result.documentName).subscribe(path => {
        //     if (path != null) {
        //        //var docfileURL=configuration.documentUrl + path;
        //        var docfileURL="http://md4emr.vigiboss.com/md4coreservice/PatSummary/"+ path;
        //       // var safeurl = this.sanitizer.bypassSecurityTrustUrl(docfileURL);

        //       const getBlobFromUrl = (myImageUrl) => {
        //         return new Promise((resolve, reject) => {
        //             let request = new XMLHttpRequest();
        //             request.open('GET', myImageUrl, true);
        //             request.responseType = 'blob';
        //             request.onload = () => {
        //                 resolve(request.response);
        //             };
        //             request.onerror = reject;
        //             request.send();
        //         })
        //     }
        //     let myBlob = getBlobFromUrl(docfileURL);

        //       this.docService.getDocBlobdata(docfileURL).subscribe(dtt=>{
        //         const reader = new FileReader();
        //         this.attachmentss.documentName = result.name;
        //         this.attachmentss.documenttype = result.type;
        //         reader.onload = () => {
        //           // this.imageData = reader.result as string;       
        //           this.attachmentss.documentdata = (reader.result as string).split(',')[1];
        //         };
        //         reader.readAsDataURL(dtt as Blob);
        //        });

        //     }
        //     else {
        //       this.toastr.error("File not found");
        //     }
        //   })

        // }

      });
    }
    else {
      this.toastr.warning("Please select Patient.");
      return;
    }
  }

  openPastencounterswindow(): void {
    if (this.patId > 0) {
      CommonComponents.patientId = this.patId;
      // const dialogRef = this.dialog.open(PastNotesComponent, {
      //   width: 'auto',
      //   height: 'auto',
      //   data:{isdirect:true}
      // }

      //);
      const dialogRef = this.dialog.open(GetCCDAMessageComponent, {
        width: '950px',
        height: '900px',
        data: { patientid: CommonComponents.patientId, encounterid: null, isdirect: true }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined && result != '') {
          this.attachmentss = {
            documentName: '',
            documenttype: '',
            documentVersion: '',
            documentdata: null,
            documentPath: null
          }
          if (result.type == "xml") {
            this.attachmentss.documentName = "VisitDate" + result.visitDate.toString();
            this.attachmentss.documenttype = "xml";
            this.directMessagedetails.TransformedXML = result.HTMLMessage;
            this.directMessagedetails.encounterId = result.encounterId;
            this.encounterid = result.encounterId;
          }
          else if (result.type == "zip") {
            this.attachmentss.documentName = result.docname;
            this.attachmentss.documentdata = result.docdata;
            this.attachmentss.documenttype = "application/zip";
          }
          this.lstattachments.push(this.attachmentss);
          this.mapValuestoObject();
          // this.rxService.generateCDA_DirectMessage().subscribe(res=>{
          //  this.directMessagedetails.TransformedXML=res.HTMLMessage;           
          // this.directMessagedetails.encounterId = result.encounterId;
          // this.lstattachments.push(this.attachmentss);
          // this.mapValuestoObject();
          // });
        }

      });
    }
    else {
      this.toastr.warning("Please select Patient.");
      return;
    }
  }
  Activeclass = "I"
  lionclick(type: string, evn: any) {
    this.inboxProp = true;
    this.composeProp = false;
    this.Activeclass = type;
    this.inboxViewMail = false;
    this.GetDirectMessagesDetails(type);
    //     var ul = document.getElementById("list");

    // const listItems :HTMLCollectionOf<HTMLLIElement> = li.getElementsByTagName("li");

    // for(const li of  Object.keys(listItems)){


    // }
  }
  inboxcount: number = 0
  isReaded: boolean = true;
  GetDirectMessagesDetails(type: string) {
    this.spinner.show();
    this.msgservice.getDirectMessages().subscribe(data => {
      if (type == "I") {
        // data = data.filter(c => c.isReceived == true && c.messageTo.includes(this.directaddress));
        data = data.filter(c => c.messageTo.includes(this.directaddress));
        //this.inboxcount = data.length;
        this.inboxcount = data.filter(i => i.isReaded == false).length;
      }
      if (type == "S")
        data = data.filter(c => (c.messageFrom == this.directaddress) && (c.Status == null || (c.Status != null && (!c.Status.includes('Queued') && !c.Status.includes('Error') && !c.Status.includes('Failed')))));
      if (type == "O")
        data = data.filter(c => (c.Status != null && (c.Status.includes('Queued') || c.Status.includes('Error') || c.Status.includes('Failed'))));
      this.dmDataSource.data = data;

      // this.dmDataSource.paginator = this.paginator;
      this.dmDataSource.filterPredicate = this.createAllOrdersFilter();
      this.spinner.hide();
    }, (err: any) => {
      console.log(err);
      this.spinner.hide();
    });
  }

  createAllOrdersFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (data.messageFrom === null ? "" : data.messageFrom).toLowerCase().indexOf(searchTerms.sender.toLowerCase()) !== -1
        && (data.subject === null ? "" : data.subject).toLowerCase().indexOf(searchTerms.subject.toLowerCase()) !== -1
        && (data.dateTime === null ? "" : data.dateTime).toLowerCase().indexOf(searchTerms.datetime.toLowerCase()) !== -1
        && (data.Status === null ? "" : data.Status).toLowerCase().indexOf(searchTerms.Status.toLowerCase()) !== -1;
    }
    return filterFunction;
  }

  dmsgId: number;
  GetDirectMessagesInfo(msgId: number) {
    this.spinner.show();
    this.dmsgId = msgId
    this.msgservice.getDirectMessagesInfo(msgId).subscribe(data => {
      this.inboxViewMail = true;
      this.inboxProp = false;
      this.inboxObj = data;
      if (this.inboxObj.isReaded == false && this.Activeclass == "I") {
        this.msgservice.UpdateIsReadedDMInfo(msgId).subscribe((results: any) => {
          //this.toastr.success(results);
        });
      }
      this.spinner.hide();
    }, (err: any) => {
      console.log(err);
      this.spinner.hide();
    });
  }

  inboxObj: directmessageDTO
  oncellclick(ele: directmessageDTO) {
    // this.inboxViewMail = true;
    this.GetDirectMessagesInfo(ele.mId);
  }
  OnbackClick() {
    this.inboxViewMail = false;
    this.inboxProp = true;
    this.GetDirectMessagesDetails(this.Activeclass);
  }
  fromBase64(item: any, msgInboxObj: any, isPreview: any) {
    if (msgInboxObj.Type == "large") {
      isPreview = 3;
      // this.savetoSystem(item, msgInboxObj);
      //window.open("https://md4emr.vigiboss.com/md4surescriptsservice/PatSummary/MHResponses/"+item.documentPath)
    }
    // else {
    // if (!item.documentdata) {
    //   return;
    // }
    const dialogRef = this.dialog.open(SurescriptsClinicalDirectMessageComponent, {
      width: '1000px', height: isPreview ? '100%' : '300px', data: { url: '', attachedObj: item, directMsgObj: msgInboxObj, ispreview: isPreview }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined) {
      }
    });
    // if (item.documentdata) {

    //   //const dataUrl = this.sanitizer.bypassSecurityTrustUrl('data:'+item.documenttype+';base64,' + item.documentdata);
    //   const byteCharacters = atob(item.documentdata);
    //   const byteNumbers = new Array(byteCharacters.length);
    //   for (let i = 0; i < byteCharacters.length; i++) {
    //     byteNumbers[i] = byteCharacters.charCodeAt(i);
    //   }
    //   const byteArray = new Uint8Array(byteNumbers);
    //   const blob = new Blob([byteArray], { type: item.documenttype });
    //   var url = window.URL.createObjectURL(blob);
    //   window.open(url);
    // }
    // }
  }

  savetoSystem(item: any, msgInboxObj: any) {

    var FileSaver = require('file-saver');
    // var blob = new Blob(decode(item.documentdata)[0], { type: item.documenttype + "charset=utf-8" });
    if (item.documentdata != null) {
      const byteCharacters = atob(item.documentdata);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: item.documenttype });

      FileSaver.saveAs(blob, item.documentName);
    }
    else {
      if (msgInboxObj.CDAXML != null) {
        const blob = new Blob([msgInboxObj.CDAXML], { type: 'application/xml' });
        FileSaver.saveAs(blob, item.documentName);
      }
    }
  }

  previewFiles(item: any, msgInboxObj: any) {

    if (item.documentdata != null) {
      const byteCharacters = atob(item.documentdata);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: item.documenttype });
      if (item.documentName.toLowerCase().includes('zip')) {
        var jsZip = require('jszip')
        let filesarrObj: any = [];
        const thisself: any = this;
        jsZip.loadAsync(blob).then(function (zip) {

          Object.keys(zip.files).forEach(async function (filename) {
            zip.files[filename].async('string').then(async function (fileData) {
              //alert(fileData) // These are your file contents 
              const _fileobject = {
                filename: filename,
                filedata: fileData
              }
              await filesarrObj.push(_fileobject);

            })

          })

          setTimeout(() => {
            thisself.dialog.open(ViewzipfilesComponent, {
              width: '1000px',
              height: '1000px',
              data: { filearr: filesarrObj }
            });
          }, 2000);

          // dialogRef.afterClosed.subscribe({

          // });
        })
      }
      else {
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      }
      // FileSaver.saveAs(blob, item.documentName);
    }
  }

  inboxDiscard() {
    this.inboxProp = true;
    this.composeProp = false;
    this.inboxViewMail = false;
    if (this.isorder == true) {
      this.dialog.closeAll();
    }
  }
  deletedoc(docitem) {
    var idx = this.lstattachments.indexOf(docitem);
    if (idx != -1)
      this.lstattachments.splice(idx, 1);
  }
  clearcompose() {
    this.directmessageform.patchValue({
      msgTo: '',
      msgCc: '',
      msgSubject: '',
      msgPatientname: '',
      msgPlainText: '',
    });
    this.lstattachments = [];
    this.initEditor.clear();
  }
  onrefreshclick() {
    this.sharedService.getAllDMResponse(1).subscribe(data => {
      this.ngOnInit();
    },
      (err: any) => console.log(err)

    );
  }
  ValidationMessageJson: any;
  reconsileMessage(item: any, msgInboxObj: any) {
    // if (msgInboxObj.CDAXML == null && item.documenttype == 'application/xml' && item.documentdata != null)
    // {

    //   }
    this.ValidationMessageJson = null;
    this.msgservice.ValidateDirectCDAMessage(this.dmsgId.toString()).subscribe(data => {
      const parsedJs = JSON.parse(data);
      this.ValidationMessageJson = {
        ccdaDocumentType: parsedJs.resultsMetaData.ccdaDocumentType,
        ccdaFileName: parsedJs.resultsMetaData.ccdaFileName,
        ccdaVersion: parsedJs.resultsMetaData.ccdaVersion,
        objectiveProvided: parsedJs.resultsMetaData.objectiveProvided,
        ResultsMetadata: parsedJs.resultsMetaData.resultMetaData,
        serviceError: parsedJs.resultsMetaData.serviceError,
        ccdaValidationResults: parsedJs.ccdaValidationResults,
        vocabularyValidationConfigurationsCount: parsedJs.resultsMetaData.vocabularyValidationConfigurationsCount,
        vocabularyValidationConfigurationsErrorCount: parsedJs.resultsMetaData.vocabularyValidationConfigurationsErrorCount,
        severityLevel: parsedJs.resultsMetaData.severityLevel,
        totalConformanceErrorChecks: parsedJs.resultsMetaData.totalConformanceErrorChecks
      }
      //if (this.fnHasNoErrors() == true) {+
      if (msgInboxObj.CDAXML != null)
        sessionStorage.setItem("XMLFileString", msgInboxObj.CDAXML.toString());
      sessionStorage.setItem("ValidationMessageJson", JSON.stringify(this.ValidationMessageJson));
      sessionStorage.setItem("DirectMsgId", this.dmsgId.toString());
      this.router.navigateByUrl("/ImportCDAXML");
      // } else {

      // }

      this.spinner.hide();
    }, (err: any) => {
      console.log(err);
      this.spinner.hide();
    });

  }
  fnHasNoErrors(): boolean {
    // if (this.ValidationMessageJson.ccdaValidationResults)
    //   return false;
    return this.ValidationMessageJson.ccdaValidationResults.some(function (el) {
      return el.type.indexOf('Error') > -1;
    });

    // return this.ValidationMessageJson.ccdaValidationResults.filter(i => i.type.indexOf('Error') > -1).length>0;
  }
  fileData;
  fnextractFiles(fileList) {
    const jsZip = require('jszip');
    jsZip.loadAsync(fileList[0]).then((zip) => { // <----- HERE
      Object.keys(zip.files).forEach((filename) => { // <----- HERE
        zip.files[filename].async('string').then((fileData) => { // <----- HERE
          this.fileData = this.fileData + '**$$##$$**' + fileData;
        });
      });
    });
  }

  private getZipFile(data: any) {
    const blob = new Blob([data['_body']], { type: 'application/zip' });

    const a: any = document.createElement('a');
    document.body.appendChild(a);

    a.style = 'display: none';
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    // a.download = test.zip;
    a.click();
    window.URL.revokeObjectURL(url);

  }

  mapValuestoObjectforClinicalSummary() {
    this.directMessagedetails.patId = this.data.patientId;
    this.directaddress = this.data.directAddress;
    this.attachmentss.documentName = "VisitDate" + this.data.appointmentDate//result.visitDate.toString();
    this.attachmentss.documenttype = "xml";
    this.directMessagedetails.TransformedXML = this.data.xmlInfo;
    this.directMessagedetails.htmlText = this.data.HtmlPath;
    this.directMessagedetails.encounterId = this.data.encounterId;
    this.lstattachments.push(this.attachmentss);
    this.directMessagedetails.attachment = [];
    this.directMessagedetails.attachment = this.lstattachments;
  }
}
